/* Accessories Recommendations widget  v3 */
(function(){
  var WRAP = '#sms-acc-recs', LIST = '#sms-acc-recs-list';
  var ROOT_SEL = '[data-sms-acc-recs], .sms-acc-recs, #sms-acc-recs';
  var LIST_SEL = '[data-sms-acc-list], .sms-acc-recs__list, #sms-acc-recs-list';
  var SOURCE = '#sms-techdata-source .tech-data-root, #sms-techdata-source.tech-data-root, #sms-acc-source .acc-root';

  function initAll(scope){
    var context = scope || document;
    var roots = [];
    if (context.matches && context.matches(ROOT_SEL)) roots.push(context);
    if (context.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(context.querySelectorAll(ROOT_SEL)));
    }
    roots.forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event){
    initAll(event.target || document);
  });

  function initRoot(root){
    if(!root) return;
    if(root.getAttribute('data-sms-acc-initialized') === '1') return;

    var list = root.querySelector(LIST_SEL) || root.querySelector(LIST);
    if(!list) return;
    root.setAttribute('data-sms-acc-initialized', '1');

    // collapse/expand
    var tgl = root.querySelector('.sms-acc-recs__toggle');
    if (tgl){
      tgl.addEventListener('click', function(){
        var open = tgl.getAttribute('aria-expanded') === 'true';
        tgl.setAttribute('aria-expanded', String(!open));
        list.style.display = open ? 'none' : '';
        tgl.textContent = open ? '▸' : '▾';
      });
    }

    var src = document.querySelector(SOURCE);
    if(!src){ renderText('No accessories.', list); return; }

    var jsonUrl = src.getAttribute('data-techdata-json') || '';
    var bucketBase = src.getAttribute('data-techdata-bucket-base') || '';
    var bucketCount = Number(src.getAttribute('data-techdata-bucket-count')) || 64;
    var prodSku = src.getAttribute('data-techdata-prod-sku') || '';
    var rawVar  = src.getAttribute('data-techdata-variant-skus') || '[]';
    var varSkus = safeParseJson(rawVar);
    var wanted  = normalizeAndDedupeSkus(prodSku, varSkus);
    var lookup = wanted.slice();

    wanted.forEach(function(sku){
      deriveMrCoolComponents(sku).forEach(function(component){
        lookup.push(component);
      });
    });

    if(!jsonUrl && !bucketBase) { renderText('No accessories.', list); return; }

    var loadPromise = window.SMSTecinfoLoader
      ? window.SMSTecinfoLoader.loadForSkus({
          baseUrl: bucketBase,
          bucketCount: bucketCount,
          fallbackUrl: jsonUrl,
          skus: lookup
        })
      : fetch(jsonUrl, {cache:'force-cache'})
          .then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.text(); })
          .then(function(txt){
            try { return JSON.parse(txt); }
            catch(e){
              const cleaned = txt.replace(/^\uFEFF/,'').replace(/&quot;|&#34;/g,'"').replace(/&amp;/g,'&');
              return JSON.parse(cleaned);
            }
          });

    loadPromise
      .then(function(raw){
        var db = normalizeDb(raw);
        renderGrouped(db, wanted, list);
      })
      .catch(function(err){
        console.warn('acc-recs load/parse failed:', err);
        renderText('Accessories temporarily unavailable.', list);
      });
  }

  /* ---------- DB shape ---------- */
  function normalizeDb(raw){
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw.items)) return raw.items;
    if (raw && Array.isArray(raw.records)) return raw.records;
    if (raw && typeof raw==='object') return [raw];
    return [];
  }

  /* ---------- TYPE MAP + heuristics ---------- */
  var TYPE_ORDER = [
    'Line set covers',
    'Line Sets',
    'Wall Brackets / Condenser Pad',
    'Heat Kit',
    'Cleaning Kit',
    'Couplers',
    'Thermostat',
    'Conduit Cables',
    'Disconnect Box',
    'Rubber Feet Mounting Set',
    'Ground Stands',
    'Other Accessories'
  ];
  var ACC_TYPE_SETS = (function(){
    function S(arr){ return new Set(arr.map(String)); }
    return {
      'Line set covers': S(['7420475277427','7784329478259','8004649517171','8004667080819','8053617295475']),
      'Line Sets': S(['8056140103795','7347732283507','8014110228595','8014232748147','8014250672243','8014258929779','8014268104819','8052349042803','8048835068019','8014321451123','7347732283507','7871035375731','7871312920691','7347983646835','7871070437491','7871408996467','7346828476531','7871160057971','7871417024627','7346841485427','7347980533875','7871217598579','8037632344179','8036342694003','8036336730227','8036351639667','8036331913331','8055997857907','8056020729971']),
      'Wall Brackets / Condenser Pad': S(['8111079882867','7855248081011','8004737138803','8004764401779','7850596696179','8004698243187','7420483698803']),
      'Heat Kit': S(['7932186591347','7932195995763','7932199600243','7932201205875','7932202352755','7992329470067','7992329994355','7992330780787','7992328749171','7842623127667','7842622210163','7812784914547','7842621751411','8014096859251','8014095286387','8014094467187','8014092697715','8014080573555','8318898045043','8318904008819','8318907646067','8318912135283','8318914265203']),
      'Cleaning Kit': S(['7855129690227']),
      'Couplers': S(['7855235006579','7855238676595']),
      'Thermostat': S(['7800311185523','8056167891059','8056169431155','8062486544499']),
      'Conduit Cables': S(['7850574938227']),
      'Disconnect Box': S(['7850581426291','8004678910067','7850578018419']),
      'Rubber Feet Mounting Set': S(['8004578836595']),
      'Ground Stands': S(['8004777836659','7784261976179','7784222031987'])
    };
  })();
  function getTypeForProductId(pid){
    if (!pid) return '';
    pid = String(pid).trim();
    for (var i=0;i<TYPE_ORDER.length;i++){
      var t = TYPE_ORDER[i], set = ACC_TYPE_SETS[t];
      if (set && set.has(pid)) return t;
    }
    return '';
  }
  function classifyType(p){
    var t = getTypeForProductId(p && p.product_id);
    if (t) return t;
    var label = (p && (p.label||'')).toLowerCase();
    var handle = (p && p.handle)||'';
    var url = (p && p.url)||'';
    var path = (handle || handleFrom(url) || '').toLowerCase();
    var s = label + ' ' + path;
    if (/\b(line[\s-]?set|installation kit|pre[-\s]?flared|copper)\b/.test(s) || /\b\d+ft\b/.test(s) || /1\/4|3\/8|1\/2|5\/8/.test(s)) return 'Line Sets';
    if (/\b(cover|duct|pvc)\b/.test(s) && /line/.test(s)) return 'Line set covers';
    if (/\b(bracket|wall bracket|condenser pad|pad)\b/.test(s)) return 'Wall Brackets / Condenser Pad';
    if (/\b(heat kit|heater|kw)\b/.test(s)) return 'Heat Kit';
    if (/\b(thermostat|smart.*stat)\b/.test(s)) return 'Thermostat';
    if (/\b(disconnect|fusible|non[-\s]?fusible)\b/.test(s)) return 'Disconnect Box';
    if (/\b(coupler|union)\b/.test(s)) return 'Couplers';
    if (/\b(conduit|cable|whip|data wire)\b/.test(s)) return 'Conduit Cables';
    if (/\b(clean|flush|coil cleaner)\b/.test(s)) return 'Cleaning Kit';
    if (/\b(rubber feet|anti[-\s]?vibration)\b/.test(s)) return 'Rubber Feet Mounting Set';
    if (/\b(stand|ground stand)\b/.test(s)) return 'Ground Stands';
    return 'Other Accessories';
  }

  /* ---------- BTU helpers ---------- */
  function btuFromSpecs(specs){
    var raw = specs && (specs['BTU Rated'] || specs['Rated Capacity Btu/h'] || specs['Capacity (Btu/h)'] || '');
    var n = Number(String(raw).replace(/[^0-9.]/g,'')); if(!n) return '';
    return String(Math.round(n/1000)*1000);
  }
  function btuFromSku(sku){
    var up = String(sku||'').toUpperCase();
    var m = up.match(/(^|[^0-9])(06|09|12|15|16|18|24|30|36|42|48|60)([^0-9]|$)/);
    if (m) return String(Number(m[2])*1000);
    var m2 = up.match(/(6000|9000|12000|15000|16000|18000|24000|30000|36000|42000|48000|60000)/);
    return m2 ? m2[1] : '';
  }
  function prettyBtu(n){ n=Number(n)||0; return n.toLocaleString()+' BTU'; }
  function btuKeyFromRec(rec){ return btuFromSpecs(rec.specs)||btuFromSku(rec.sku)||''; }

  /* ---------- core render ---------- */
  function renderGrouped(db, wantedSkus, targetList){
    var map = Object.create(null);
    db.forEach(function(r){ if(r && r.sku) map[String(r.sku).toUpperCase()] = r; });

    // expand MRCOOL + fuzzy
    var seen = Object.create(null), all=[];
    (wantedSkus||[]).forEach(function(s){ if(!s) return; all.push(s); deriveMrCoolComponents(s).forEach(c=>all.push(c)); });
    var wanted = all.filter(s=>{var up=String(s).toUpperCase(); if(seen[up]) return false; seen[up]=1; return true;});

    var withAcc=[], skuInfo=Object.create(null);
    wanted.forEach(function(raw){
      var up=String(raw).toUpperCase(), rec=map[up];
      if(!rec){
        var parts=up.split('-'), hp=parts.indexOf('HP');
        if(hp>-1 && hp<parts.length-1){
          var head=parts.slice(0,hp+2).join('-'), tail=parts.slice(hp+2).join('-');
          rec = mrCoolFuzzyFind(head, tail, map);
        }
      }
      if(rec && Array.isArray(rec.accessories) && rec.accessories.length){
        withAcc.push(rec);
        skuInfo[String(rec.sku)] = {btu: btuKeyFromRec(rec)};
      }
    });
    if(!withAcc.length){ renderText('No accessories for this configuration.', targetList); return; }

    // type-first buckets: {type:{sku:[items]}}
    var buckets = Object.create(null);
    var skuOrder = [];
    withAcc.forEach(function(rec){
      var sku = String(rec.sku);
      skuOrder.push(sku);
      acc_normalizeList(rec.accessories).forEach(function(p){
        var typ = classifyType(p);
        if(!buckets[typ]) buckets[typ]=Object.create(null);
        if(!buckets[typ][sku]) buckets[typ][sku]=[];
        buckets[typ][sku].push(p);
      });
    });
    skuOrder = Array.from(new Set(skuOrder)).sort();

    // build type tabs + panes
    var types = TYPE_ORDER.filter(function(t){ return !!buckets[t]; });
    var html = '';
    var nav = '<div class="sms-acc-type-tabs" role="tablist">'
      + types.map(function(t,i){
          var id = 'pane-'+slug(t);
          return '<button type="button" class="sms-acc-type-tab'+(i===0?' active':'')+'" role="tab" aria-selected="'+(i===0)+'" aria-controls="'+id+'">'+esc(t)+'</button>';
        }).join('')
      + '</div>';

    var panes = types.map(function(typ, idx){
      var paneId = 'pane-'+slug(typ);
      // dedupe per SKU
      var dedup = {};
      skuOrder.forEach(function(sku){ dedup[sku] = dedupeAccList((buckets[typ]||{})[sku]||[]); });

      var body = '';
      if (typ === 'Line Sets'){
        body = renderLineSetsType(dedup, skuInfo);
      } else {
        var lists = skuOrder.map(function(s){return dedup[s]||[];});
        var nonEmpty = lists.filter(function(l){return l&&l.length;});
        var sigs = nonEmpty.map(signatureOf).filter(Boolean);
        var uniqueSigs = Array.from(new Set(sigs));
        if (nonEmpty.length && uniqueSigs.length <= 1){
          body += renderGroupSection('Recommended', nonEmpty[0]);
        } else {
          skuOrder.forEach(function(sku){
            var list = dedup[sku]; if(!list.length) return;
            var btu = skuInfo[sku] && skuInfo[sku].btu;
            var title = btu ? ('For your '+esc(prettyBtu(btu))+' Indoor Head') : ('For '+esc(sku));
            body += renderGroupSection(title, list);
          });
        }
      }

      return '<section class="sms-acc-type-pane'+(idx===0?' active':'')+'" id="'+paneId+'" role="tabpanel" '+(idx===0?'':' hidden')+'>'+body+'</section>';
    }).join('');

    var container = targetList || document.querySelector(LIST);
    if(!container) return;
    container.innerHTML = nav + panes;

    // hydrate initial active pane, keep lists hidden until ready → correct in-stock sorting
    var activePane = container.querySelector('.sms-acc-type-pane.active');
    hydrateInitialPane(container, activePane);

    // type tab switching
    container.querySelector('.sms-acc-type-tabs').addEventListener('click', function(e){
      var btn = e.target.closest('.sms-acc-type-tab'); if(!btn) return;
      var id = btn.getAttribute('aria-controls');
      // tabs
      this.querySelectorAll('.sms-acc-type-tab').forEach(function(b){
        var on = b===btn; b.classList.toggle('active', on); b.setAttribute('aria-selected', on?'true':'false');
      });
      // panes
      container.querySelectorAll('.sms-acc-type-pane').forEach(function(p){
        var on = (p.id===id); p.toggleAttribute('hidden', !on); p.classList.toggle('active', on);
        if(on) hydratePane(p);
      });
    });
  }

  /* ---------- pane hydration gate ---------- */
  function hydrateInitialPane(container, pane){
    var disclosure = container.closest('[data-sms-mobile-disclosure="accessories"]');
    if (!disclosure) { hydratePane(pane); return; }
    var media = window.matchMedia('(max-width: 749px)');
    var loading = disclosure.querySelector('[data-sms-mobile-accessory-loading]');
    var started = false;
    function start(){
      if (started || (media.matches && !disclosure.open)) return;
      started = true;
      disclosure.removeEventListener('toggle', start);
      media.removeEventListener('change', start);
      if (loading) loading.hidden = false;
      hydratePane(pane).finally(function(){ if (loading) loading.hidden = true; });
    }
    disclosure.addEventListener('toggle', start);
    media.addEventListener('change', start);
    start();
  }

  function hydratePane(pane){
    if (!pane || pane.getAttribute('data-pane-hydrated')==='1') {
      // still need to wire pagers in case first time visible
      pane && wirePagersIn(pane);
      return Promise.resolve();
    }
    var lists = Array.from(pane.querySelectorAll('.sms-acc-list'));
    var hydrations = lists.map(function(listEl){ return hydrateIn(listEl); });
    return Promise.all(hydrations).then(function(){
      wirePagersIn(pane);
      pane.setAttribute('data-pane-hydrated','1');
    });
  }
  function wirePagersIn(scope){
    scope.querySelectorAll('.sms-acc-group').forEach(function(g){
      bindPager(g); updatePager(g); g.setAttribute('data-pager-bound','1');
    });
    // BTU chips inside Line Sets panes
    wireBtuChips(scope);
    var chipsRow = scope.querySelector('.sms-btu-chips');
    if (chipsRow && chipsRow.querySelectorAll('.sms-btu-chip').length <= 1) chipsRow.hidden = true;
  }

  /* ---------- per-type renderers ---------- */
  function renderGroupSection(title, items){
    var id = 'recs-'+Math.random().toString(36).slice(2,8);
    return (
      '<section class="sms-acc-group" id="'+id+'" data-pagesize="3" data-page="1">'
      +  '<h4 class="sms-acc-sku-subtitle">'+esc(title)+'</h4>'
      +  '<div class="sms-acc-list" hidden>'+ (items||[]).map(renderRow).join('') +'</div>'
      +  '<div class="sms-acc-pager"><button class="prev" type="button" aria-label="Previous">‹</button>'
      +    '<span class="page">1 / 1</span><button class="next" type="button" aria-label="Next">›</button>'
      +  '</div>'
      +'</section>'
    );
  }

  function renderLineSetsType(dedupBySku, skuInfo){
    var btuLists = Object.create(null);
    Object.keys(dedupBySku).forEach(function(sku){
      var btu = (skuInfo[sku] && skuInfo[sku].btu) || '';
      if (!btu) return;
      btuLists[btu] = dedupBySku[sku];
    });

    var groups = [], sigToIdx = Object.create(null);
    Object.keys(btuLists).sort(function(a,b){return Number(a)-Number(b);}).forEach(function(btu){
      var list = btuLists[btu]||[];
      var sig = signatureOf(list); if(!sig) return;
      if (sigToIdx[sig]==null){ sigToIdx[sig]=groups.length; groups.push({btus:[btu], list:list}); }
      else groups[sigToIdx[sig]].btus.push(btu);
    });

    if(!groups.length){
      var any = Object.values(dedupBySku).find(function(x){return (x||[]).length;}) || [];
      return any.length ? renderGroupSection('Recommended', any) : '<p>No items.</p>';
    }

    var allBtus = groups.flatMap(function(g){return g.btus;}).sort(function(a,b){return Number(a)-Number(b);});
    var chips = '<div class="sms-btu-chips" role="group" aria-label="Select indoor head size">';
    allBtus.forEach(function(b,i){
      chips += '<button type="button" class="sms-btu-chip'+(i===0?' is-active':'')+'" data-btu="'+esc(b)+'">'+esc(Number(b).toLocaleString())+' BTU</button>';
    });
    chips += '</div>';

    var body = '';
    groups.forEach(function(g, idx){
      var title = 'For your '+g.btus.map(function(b){return Number(b).toLocaleString();}).join(', ')+' BTU Indoor Head';
      var id = 'recs-btu-'+idx;
      body += '<section class="sms-acc-group sms-btu-section" id="'+id+'" data-btu-set="'+esc(g.btus.join(','))+'" data-pagesize="3" data-page="1">';
      body +=   '<h4 class="sms-acc-sku-subtitle">'+esc(title)+'</h4>';
      body +=   '<div class="sms-acc-list" hidden>'+ (g.list||[]).map(renderRow).join('') +'</div>';
      body +=   '<div class="sms-acc-pager"><button class="prev" type="button" aria-label="Previous">‹</button><span class="page">1 / 1</span><button class="next" type="button" aria-label="Next">›</button></div>';
      body += '</section>';
    });

    return chips + body;
  }

  function wireBtuChips(root){
    var chips = root.querySelectorAll('.sms-btu-chip');
    if (!chips.length) return;
    var sections = Array.from(root.querySelectorAll('.sms-btu-section'));
    root.addEventListener('click', function(e){
      var btn = e.target.closest('.sms-btu-chip'); if (!btn) return;
      var btu = btn.getAttribute('data-btu');
      chips.forEach(function(c){ c.classList.toggle('is-active', c===btn); });
      sections.forEach(function(sec){
        var set = (sec.getAttribute('data-btu-set')||'').split(',');
        var on = set.indexOf(btu)>-1;
        sec.toggleAttribute('hidden', !on);
        if(on){
          var list = sec.querySelector('.sms-acc-list');
          if (list && list.hasAttribute('hidden')) hydrateIn(list).then(function(){ bindPager(sec); updatePager(sec); });
          else { bindPager(sec); updatePager(sec); }
        }
      });
    });
  }

  /* ---------- pager helpers ---------- */
  function bindPager(grp){
    if (grp.getAttribute('data-pager-bound') === '1') return;
    grp.setAttribute('data-pager-bound','1');
    grp.querySelector('.prev').addEventListener('click', function(){
      grp.setAttribute('data-page', Math.max(1, Number(grp.getAttribute('data-page'))-1));
      updatePager(grp);
    });
    grp.querySelector('.next').addEventListener('click', function(){
      grp.setAttribute('data-page', Number(grp.getAttribute('data-page'))+1);
      updatePager(grp);
    });
  }
  function updatePager(grp){
    var size = Number(grp.getAttribute('data-pagesize'))||3;
    var listEl = grp.querySelector('.sms-acc-list');

    // remove old ghosts
    listEl.querySelectorAll('.sms-acc-ghost').forEach(function(n){ n.remove(); });

    var rows = Array.from(listEl.querySelectorAll(':scope > .sms-acc-row:not(.sms-acc-ghost)'));
    var pages = Math.max(1, Math.ceil(rows.length/size));
    var page = Math.min(Number(grp.getAttribute('data-page'))||1, pages);

    rows.forEach(function(r,i){ r.style.display = (i>= (page-1)*size && i < page*size) ? 'flex' : 'none'; });

    var sample = rows.find(function(r){ return r.style.display!=='none'; });
    if(sample) grp.style.setProperty('--acc-row-h', sample.getBoundingClientRect().height+'px');

    var visibleCount = rows.filter(function(r){ return r.style.display!=='none'; }).length;
    for(var i=visibleCount; i<size; i++){
      var ghost = document.createElement('div'); ghost.className = 'sms-acc-row sms-acc-ghost'; listEl.appendChild(ghost);
    }

    grp.querySelector('.page').textContent = page+' / '+pages;
    grp.querySelector('.prev').disabled = page<=1;
    grp.querySelector('.next').disabled = page>=pages;
    grp.setAttribute('data-page', page);
  }


  function withAccSrc(url, src){
    try{
      const u = new URL(url, location.origin);
      u.searchParams.set('acc_source', src); // e.g. "acc_recs"
      return u.href;
    }catch(_){ return url; }
  }


  /* ---------- row render + hydration ---------- */
  function renderRow(p, i){
    var lbl = esc(p.label||'');
    return (
      '<div class="sms-acc-row" data-idx="'+i+'" data-avail="0"'
        + (p.handle?(' data-handle="'+esc(p.handle)+'"'):'')
        + (p.product_id?(' data-product-id="'+esc(p.product_id)+'"'):'')
        + (p.url?(' data-url="'+esc(p.url)+'"'):'') + '>'
      + '  <div class="sms-acc-thumb sms-acc-loading"></div>'
      + '  <div class="sms-acc-body">'
      + '    <p class="sms-acc-title">'+lbl+'</p>'
      + '    <div class="sms-acc-price"></div>'
      + '    <div class="sms-acc-variant"></div>'
      + '  </div>'
      + '  <div class="sms-acc-add"><button type="button" disabled>Loading…</button></div>'
      + '</div>'
    );
  }

  function hydrateIn(listEl){
    var rows = Array.from(listEl.querySelectorAll('.sms-acc-row'));
    if(!rows.length){ listEl.removeAttribute('hidden'); return Promise.resolve(); }
    // hide until rows hydrated and resorted
    listEl.setAttribute('hidden','');
    var jobs = rows.map(function(row){
      if(row.getAttribute('data-hydrated')==='1') return Promise.resolve();
      row.setAttribute('data-hydrated','1');
      var handle = row.getAttribute('data-handle');
      var url    = row.getAttribute('data-url');
      return fetchProduct(handle).then(function(prod){ hydrateRow(row, prod, url); });
    });
    return Promise.all(jobs).then(function(){
      resortByAvail(listEl);
      listEl.removeAttribute('hidden');
    });
  }
  document.addEventListener('sms:acc:added', function(e){
    if (window.__smsAccSourceMarked) return;
    if (!e || !e.detail || e.detail.source !== 'recs') return;
    window.__smsAccSourceMarked = true;
    try {
      var fd = new FormData();
      fd.append('attributes[acc_source]', 'acc_recs');
      fd.append('attributes[acc_source_ts]', new Date().toISOString());
      fetch('/cart/update.js', { method:'POST', body: fd, credentials:'same-origin' });
    } catch(_){}
  }, { passive: true, once: true });

  function hydrateRow(row, prod, fallbackUrl){
    var thumb = row.querySelector('.sms-acc-thumb');
    var title = row.querySelector('.sms-acc-title');
    var price = row.querySelector('.sms-acc-price');
    var vbox  = row.querySelector('.sms-acc-variant');
    var btn   = row.querySelector('.sms-acc-add button');

    if(!prod){
      thumb.innerHTML = '';
      title.innerHTML = fallbackUrl
      ? ('<a href="'+withAccSrc(fallbackUrl,'acc_recs')+'" target="_blank" rel="noopener">'+title.textContent+'</a>')
      : title.textContent;
      btn.textContent = fallbackUrl?'View':'Unavailable';
      btn.disabled = !fallbackUrl;
      if(fallbackUrl) btn.addEventListener('click', function(){ window.open(fallbackUrl,'_blank'); });
      setAvail(row, true); return;
    }

    title.innerHTML = '<a href="'+withAccSrc(prod.url,'acc_recs')+'" target="_blank" rel="noopener">'+esc(prod.title)+'</a>';
    var img = (prod.images && prod.images[0]) ? sized(prod.images[0], 240) : '';
    row.querySelector('.sms-acc-thumb').classList.remove('sms-acc-loading');
    thumb.innerHTML = img ? '<img loading="lazy" src="'+img+'" alt="'+esc(prod.title)+'">' : '';

    var vars = Array.isArray(prod.variants)?prod.variants:[];
    if(vars.length>1){
      var html = '<label><span class="visually-hidden">Select</span><select class="sms-acc-var">';
      vars.forEach(function(v){ html += '<option value="'+v.id+'" '+(v.available?'':'disabled')+'>'+esc(v.title)+(v.available?'':' (Sold Out)')+'</option>'; });
      html += '</select></label>';
      vbox.innerHTML = html;
    } else vbox.innerHTML = '';

    var initV = vars.find(function(v){ return v.available; }) || vars[0] || null;
    if(initV){
      price.textContent = money(initV.price);
      btn.disabled = !initV.available;
      btn.textContent = initV.available?'Add to Cart':'Sold Out';
      btn.setAttribute('data-vid', initV.id);
    } else { price.textContent=''; btn.disabled=true; btn.textContent='Sold Out'; }

    setAvail(row, vars.some(function(v){ return !!v.available; }));

    var sel = vbox.querySelector('select');
    if (sel){
      sel.addEventListener('change', function(e){
        var v = vars.find(function(x){return String(x.id)===String(e.target.value);}); if(!v) return;
        price.textContent = money(v.price);
        btn.disabled = !v.available;
        btn.textContent = v.available?'Add to Cart':'Sold Out';
        btn.setAttribute('data-vid', v.id);
        setAvail(row, vars.some(function(x){return !!x.available;})); // keep order if variant toggles
      });
    }

    btn.addEventListener('click', function(){
      var vid = btn.getAttribute('data-vid'); if(!vid || btn.disabled) return;
      btn.disabled=true; btn.textContent='Adding…';
      addToCart(vid, 1, { acc_recomended: '1' }).then(function(ok){
        btn.disabled=false; btn.textContent = ok?'Added!':'Error';
        if(ok) document.dispatchEvent(new CustomEvent('sms:acc:added',{detail:{variant_id:vid, source:'recs'}}));
      });
    });
  }

  function resortByAvail(listEl){
    var rows = Array.from(listEl.querySelectorAll(':scope > .sms-acc-row'));
    rows.sort(function(a,b){
      return Number(b.getAttribute('data-avail')||'0') - Number(a.getAttribute('data-avail')||'0');
    });
    rows.forEach(function(r){ listEl.appendChild(r); });
  }
  function setAvail(row, avail){
    row.setAttribute('data-avail', avail?'1':'0');
    // do not resort here; resort happens after batch hydration for stable first paint
  }

  /* ---------- list utils ---------- */
  function acc_normalizeList(arr){
    if (!Array.isArray(arr) || !arr.length) return [];
    var out=[], seen=Object.create(null);
    function pushOne(lbl, url, pid){
      pid = pid ? String(pid).trim() : '';
      var key = pid || handleFrom(url) || url;
      if (!key || seen[key]) return;
      seen[key]=1;
      out.push({ label: lbl||'', url:url||'', product_id:pid, handle: handleFrom(url) });
    }
    arr.forEach(function(item){
      if (!item) return;
      if (typeof item === 'string'){ pushOne(item, detectUrl(item), ''); return; }
      if (typeof item === 'object'){
        var lbl = item.label || item.title || item.name || '';
        var url = item.url || item.link || item.href || item.product_url || '';
        var pid = item.product_id || item.id || '';
        pushOne(lbl, url, pid);
        (item.alt_products||[]).forEach(function(ap){ if(ap) pushOne(lbl, ap.url||'', ap.product_id||''); });
      }
    });
    return out;
  }
  function signatureOf(arr){
    return acc_normalizeList(arr).map(function(p){return p.product_id || p.handle || p.url;}).filter(Boolean).sort().join('|');
  }
  function dedupeAccList(arr){
    var out=[], seen=Object.create(null);
    acc_normalizeList(arr).forEach(function(p){
      var k = (p.product_id && String(p.product_id)) || p.handle || p.url || '';
      if (!k || seen[k]) return; seen[k]=1; out.push(p);
    });
    return out;
  }

  /* ---------- MRCOOL helpers ---------- */
  function deriveMrCoolComponents(baseSku){
    var up=String(baseSku||'').toUpperCase(), parts=up.split('-'), hp=parts.indexOf('HP');
    if(hp===-1) return []; var head=parts.slice(0,hp+1), tail=parts.slice(hp+1);
    function build(insert){ return [...head, insert, ...tail].join('-'); }
    return [build('C'), build('WMAH'), build('MUAH')];
  }
  function mrCoolFuzzyFind(headInsert, tailWanted, map){
    var prefix=headInsert+'-', want=tailWanted.replace(/[0-9]/g,'');
    for(var up in map){ if(!up.startsWith(prefix)) continue;
      var cand=up.slice(prefix.length).replace(/[0-9]/g,''); if(cand===want) return map[up]; }
    return null;
  }

  /* ---------- misc utils ---------- */
  function safeParseJson(raw){ try{return JSON.parse(raw);}catch(e){ try{
    return JSON.parse(String(raw||'').replace(/&quot;|&#34;/g,'"').replace(/&amp;/g,'&')); }catch(_){return[];} } }
  function normalizeAndDedupeSkus(prodSku, variantSkus){
    var set=Object.create(null); function add(s){ if(s) set[s]=1; }
    add(prodSku); (variantSkus||[]).forEach(add);
    var cleaned=[]; Object.keys(set).forEach(function(sk){
      sk.split('+').forEach(function(part){ part=String(part||'').trim()
        .replace(/^(\d+)\s*[xX]\s*[-_]?/,'').replace(/^[xX]\s*(\d+)\s*[-_]?/,'')
        .replace(/[-_]?[xX]\s*\d+$/,'').replace(/\d+\s*[xX]$/,'').trim();
        if(part) cleaned.push(part); });
    });
    var out=[], seen=Object.create(null); cleaned.forEach(function(sk){
      var up=sk.toUpperCase(); if(!seen[up]){ seen[up]=1; out.push(sk); } });
    return out;
  }

  function esc(s){ return (''+s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function detectUrl(s){ if(!s) return ''; s=String(s).trim(); if(/^https?:\/\//i.test(s)) return s; if(/^www\./i.test(s)) return 'https://'+s; return ''; }
  function handleFrom(u){ if(!u) return ''; try{ var x=new URL(u, location.origin); var seg=x.pathname.split('/').filter(Boolean); var ix=seg.indexOf('products'); return ix>-1 && seg[ix+1] ? seg[ix+1] : (seg.pop()||''); }catch(e){ return ''; } }
  function sized(url,w){ try{ var u=new URL(url); u.searchParams.set('width',w||240); return u.href; }catch(e){ return url; } }
  function slug(s){ return String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,''); }

  var productCache=Object.create(null);
  function fetchProduct(handle){
    if(!handle) return Promise.resolve(null);
    if(productCache[handle]) return productCache[handle];
    productCache[handle]=fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
      .catch(function(){ return null; });
    return productCache[handle];
  }
  function money(cents){
    if (typeof Shopify!=='undefined' && Shopify.formatMoney){
      try { return Shopify.formatMoney(cents, Shopify.money_format || "${{amount}}"); } catch(e){}
    }
    return '$'+(cents/100).toFixed(2);
  }
  function addToCart(vid, qty, props){
    var fd = new FormData();
    fd.append('id', vid);
    fd.append('quantity', qty || 1);
    if (props && typeof props === 'object'){
      for (var k in props){
        if (Object.prototype.hasOwnProperty.call(props, k)){
          fd.append('properties['+k+']', String(props[k]));
        }
      }
    }
    return fetch('/cart/add.js', { method:'POST', body:fd, credentials:'same-origin' })
      .then(function(r){ return r.ok; })
      .catch(function(){ return false; });
  }
  function renderText(s, targetList){ var list=targetList || document.querySelector(LIST); if(list) list.innerHTML='<p>'+esc(s)+'</p>'; }
})();
